"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cerzeto": {
    "efddef80": [{
      "hkey": "7bd05934",
      "slug": "stazione-di-mongrassano",
      "name": "Stazione di Mongrassano",
      "primary": true,
      "skipSearch": false
    }],
    "cerzeto-scalo": [{
      "hkey": "7bd05934",
      "slug": "stazione-di-mongrassano",
      "name": "Stazione di Mongrassano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7c2155dc": [{
      "hkey": "4ecb09ad",
      "slug": "cerzeto",
      "name": "Cerzeto",
      "primary": true,
      "skipSearch": false
    }],
    "colombra": [{
      "hkey": "4ecb09ad",
      "slug": "cerzeto",
      "name": "Cerzeto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;